import { gql } from '@apollo/client';

// WE SHOULD ADD "customerDownPayment" && "monthlyPayment" later when they're available on SCHEMA

const OFFER_FIELDS = `
  zipClusterID
  offerModelDetail {
    modelCode
    modelYear
    bodyType
    trimline
    productModelCode
    modelCodeDescription
    msrp
    modelFamily
  }
  stackableOffers {
    offerType
    creditBonus
    programShortDescription
    offerDisclaimer
    programName
  }
  offerDisclaimer
  offerImageUrl
  featuredOfferImageUrl
  programName
  offerType
  programPriority
  programFromDate
  programToDate
  programShortDescription
  region
  zipClusterID
  aprRate
  creditBonus
  term
  totalDueAtSign
  customerDownPayment
  monthlyPayment
`;

// Legacy query with offerMonth (for prod until BE deploys asOfDate support)
export const US_OFFERS_SCHEMA_LEGACY = gql`
  query UsCustomerOffers($zipCode: String, $offerMonth: String, $hideLeaseOffers: Boolean) {
    usCustomerOffers(zipCode: $zipCode, offerMonth: $offerMonth, hideLeaseOffers: $hideLeaseOffers) {
      ${OFFER_FIELDS}
    }
  }
`;

// New query with asOfDate support
export const US_OFFERS_SCHEMA = gql`
  query UsCustomerOffers($zipCode: String, $asOfDate: String, $hideLeaseOffers: Boolean) {
    usCustomerOffers(zipCode: $zipCode, asOfDate: $asOfDate, hideLeaseOffers: $hideLeaseOffers) {
      ${OFFER_FIELDS}
    }
  }
`;
